const publisherPositions = [
  { key: 0, value: 'audience_network', text: 'Audience Network' },
  { key: 1, value: 'Facebook', text: 'Facebook' },
  { key: 2, value: 'Instagram', text: 'Instagram' },
  { key: 3, value: 'Messenger', text: 'Messenger' }
];

export default publisherPositions;



// WEBPACK FOOTER //
// ./src/components/common/PublisherPositions.js